export const adConfig = {
    // Set this to false to disable all ads across the entire website 
    showAdBanner: false,
};
